import "./tabs.scss";

const Tabs = ({ tabs, activeTab, onTabChange }) => {
    return (
        <div className="tabs">
            <div className="tabs__header">
                {tabs.map((tab) => (
                    <div
                        key={tab.id}
                        className={`tabs__header__tab ${
                            activeTab === tab.id ? "active" : ""
                        }`}
                        onClick={() => onTabChange(tab.id)}
                    >
                        {tab.label}
                    </div>
                ))}
            </div>
            <div className="tabs__content"></div>
        </div>
    );
};

export default Tabs;
